import { Loading } from './../../../components/Loading/Loading';
import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import StartRating from "components/StartRating/StartRating";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import { useParams } from "react-router-dom";
import { Amenities_demos } from "./constant";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import { CouponType, EventType, PhaseType, UserType } from "data/types";
import { convertServerDateToLocalDate } from "utils/convertServerDateToLocalDate";
import { useGetEventQuery, useGetPhasesByEventMutation, useLazyVerifyCouponQuery, useVerifyCouponLocalityMutation } from "store/api";
import NcInputNumberLocalities from "components/NcInputNumberLocalities/NcInputNumberLocalities";
import NcModal from "shared/NcModal/NcModal";
import { useAuth } from '../../../contexts/AuthContext';
import { TimerProvider } from "contexts/TimerContext";
import { LocalitySelectedType } from '../../../data/types';
import { Helmet } from 'react-helmet-async';

const EventPageContainer: FC<{event:EventType}> = ({event}) => {

  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);

  const eventDate = convertServerDateToLocalDate(event.startTime);
  const [phases, setPhases] = useState<PhaseType[]>([]); 
  const [rowValues, setRowValues] = useState<Record<string, number>>({});
  const [subtotal0, setSubtotal0] = useState(0);
  const [subtotal15, setSubtotal15] = useState(0);
  const [vat, setVat] = useState(0);
  const [totalCommision, setTotalCommision] = useState(0);
  const [totalCommisionVat, setTotalCommisionVat] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [subtotalVat, setSubtotalVat] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const currentTime = new Date();
  const [cantTickets, setCantTickets] = useState(0);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [coupon,setCoupon]= useState('');
  const [couponMessageError, setCouponMessageError] = useState('');
  const [verifyCoupon] = useLazyVerifyCouponQuery();
  const [verifyCouponLocality] = useVerifyCouponLocalityMutation();
  const [localities, setLocalities] = useState<any[]>([]);
  const [verifyingCoupon, setVerifyingCoupon] = useState(false);
  const [haveProfile, setHaveProfile] = useState(false);
  const [havePhone,setHavePhone] = useState(false);
  const [localitiesSelected, setLocalitiesSelected] = useState<LocalitySelectedType[]>([]);
  const [errorList,setErrorList] = useState<any[]>([]);
  
  const {isLoggedIn} = useAuth();
  

  useEffect(() => {
  let newSubtotal0 = 0;
  let newSubtotal15 = 0;
  let newVat = 0;
  let newTotalCommision = 0;
  let newTotalCommisionVat = 0;
  let newTotal = 0;
  let newSubtotal = 0;
  if (event.iva) {
    newSubtotal15 = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * (parseFloat(phase.priceWithVAT)/(1+(event.valueIva/100)));
    }, 0);
    setSubtotal15(newSubtotal15);

    newSubtotal = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.priceWithVAT;
    }, 0);
    setSubtotalVat(newSubtotal);

    newVat =  newSubtotal15 * (event.valueIva / 100);
    setVat(newSubtotal-newSubtotal15);

    newTotalCommision = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * (parseFloat(phase.commisionIva)/(1+(event.valueIva/100)));
    }, 0);
    setTotalCommision(newTotalCommision);
    newTotalCommisionVat = newTotalCommision * (event.valueIva / 100);
    setTotalCommisionVat(newTotalCommisionVat);

    const totalWithVat = newSubtotal15 + newVat + newTotalCommision + newTotalCommisionVat;
    setSubtotal(totalWithVat);

    newTotal = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.priceWithVAT;
    }, 0);
    setTotal(totalWithVat-discount);

  } else {
    newSubtotal0 = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.priceWithoutVAT;
    }, 0);
    setSubtotal0(newSubtotal0);

    newTotalCommision = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.commisionNoIva;
    }, 0);
    setTotalCommision(newTotalCommision);

    newTotalCommisionVat = newTotalCommision * (15 / 100);
    setTotalCommisionVat(newTotalCommisionVat);

    newSubtotal = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.priceWithVAT;
    }, 0);
    const subt = newSubtotal+newTotalCommision+newTotalCommisionVat;
    setSubtotal(subt);

    newTotal = phases.reduce((acc, phase) => {
      const rowValue = rowValues[phase.description] || 0;
      return acc + rowValue * +phase.priceWithVAT;
    }, 0);
    setTotal(subt-discount);
   }

   setCantTickets(phases.reduce((acc, phase) => {
    const rowValue = rowValues[phase.description] || 0;
    return acc + rowValue;
  }
  , 0));
  if(cantTickets===0){
    setDiscount(0);
    setCoupon('');
  } 
// }, [rowValues, phases, event]);
}, [rowValues, event, discount]);

  const handleRowChange = (value: number, phase: PhaseType) => {
    setDiscount(0);
    setRowValues((prev) => ({
      ...prev,
      [phase.description]: value,
    }));
    setLocalities((prev) => {
      const existingLocalityIndex = prev.findIndex(
          (loc) => loc[0] === phase.locality
      );

      if (existingLocalityIndex >= 0) {
          prev[existingLocalityIndex][1] = value;
          prev[existingLocalityIndex][3] = +phase.priceWithVAT;
          return [...prev];
      } else {
          return [...prev, [phase.locality, value, false, +phase.priceWithVAT]];
      }
  });
  };

  const [getPhasesByEvent,{data}]=useGetPhasesByEventMutation();
  const [hasDataChanged, setHasDataChanged] = useState(false); 

  useEffect(() => {
    getPhasesByEvent({event:event._id});
  }
  , [getPhasesByEvent]);
  

useEffect(() => {
  if (data && !hasDataChanged) {
    console.log(data);
    const newPhases = data?.localities?.map((localities: any) => {
      return localities.phases.map((phase: any) => ({
        _id: phase._id,
        status: phase.status,
        public: phase.public,
        position: phase.position,
        type: phase.type,
        name: phase.name,
        stock: phase.stock,
        typePublic: phase.typePublic,
        priceWithVAT: phase.priceWithVAT,
        priceWithoutVAT: phase.priceWithoutVAT,
        startDate: phase.startDate,
        endDate: phase.endDate,
        locality: phase.locality,
        log: phase.log,
        commisionIva: phase.commisionIva,
        commisionNoIva: phase.commisionNoIva,
        acronym: phase.acronym,
        description: localities.description,
        sequenceStart: phase.sequenceStart,
        typeNumbering: localities.typeNumbering,
        localityStock: localities.stock,
      }));
    });

    setPhases(newPhases?.flat());
    setLocalitiesSelected(newPhases?.map((phase: any) => ({ _id: phase[0].locality, quantity: 0, zones: [] })));
    setHasDataChanged(true); 
  }
}, [data, hasDataChanged]);

  const userData = localStorage.getItem("user");
  let user:UserType;
  if (userData) {
    user = JSON.parse(userData) as UserType;
  }

  const handleDiscount = async (e:React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if(timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async() => {
      setCoupon(value);
      await verifyDiscount(value);
    }, 500);
  }

  const verifyDiscount = async(coupon:string)=>{
    if(coupon==='') {
      setCouponMessageError('');
      setDiscount(0);
      return;
    }
    setVerifyingCoupon(true);
    const {data, error} = await verifyCoupon({code:coupon,customer:user._id,item:event._id,type:'events'});
        if(error){
          console.log(error);
          const fetchError = error as { status: number; data: { error: string; statusMessage: string } };
          if(fetchError.status === 400){
            if(fetchError.data.error === 'Validar por localidad') {
              await verifyDiscountByLocality(coupon);
            }else{
              setDiscount(0);
              setCouponMessageError('Cupón inválido');
              setVerifyingCoupon(false);
            }
          } 
        }
        if(data) {
          setCouponMessageError('');
          if(data.meta.status===200){
            const coupon:CouponType = {...data.coupon};
            if(coupon.typeDiscount==="PERCENTAGE")
              event.iva? setDiscount(((subtotal15+vat)*(coupon.valueDiscount/100))):
              setDiscount(((subtotal0+vat)*(coupon.valueDiscount/100)));
            else
              setDiscount(+coupon.valueDiscount)
            setVerifyingCoupon(false);
          }
        }
  }

  const verifyDiscountByLocality = async(code:string)=>{
    setCouponMessageError('');
    const prices = localities.map((locality) => {
      return locality[1]*locality[3];
    });
    const {data,error} = await verifyCouponLocality({code,body:{localities,prices}});
    if(error){
      console.log(error);
      const fetchError = error as { status: number; data: { error: string; statusMessage: string } };
      if(fetchError.status === 400){
        setDiscount(0);
        setCouponMessageError('Cupón inválido');
        setVerifyingCoupon(false);
      }
    }
    if(data){
      if(data.meta.status===200){
        console.log(data);
        const discounts = data.discounts;
        const discount = discounts.reduce((acc:any, discountLocal:any) => {
          return acc + discountLocal;
        }, 0);
        if(discount>0) setDiscount(discount);
        else setCouponMessageError('Cupón inválido');
        setVerifyingCoupon(false);
      }
    }
  }

  useEffect(()=>{
    verifyDiscount(coupon);
  },[total]);
  useEffect(()=>{
    // console.log(localitiesSelected);
  },[localitiesSelected]);

  const verifySeatsSelected = ()=>{
    
    let errorList:any =[];
    setErrorList([]);
    phases.forEach((phase) => {
      if(phase.typeNumbering==='Alfanumérico'){
        localitiesSelected.forEach((locality) => {
          if(locality._id===phase.locality){
            let counterSeats = 0;
            locality.zones.forEach((zone) => {
              counterSeats+=zone.seats.length;
            });
            if(counterSeats!==locality.quantity){
              errorList.push(locality.quantity + ' asientos en la localidad ' + phase.description);
            }
          }
        });
      }
    });
    setErrorList(errorList);
    setTimeout(()=>setErrorList([]),5000);
  } 

  const verifyStock =async()=>{
    const {data} = await getPhasesByEvent({event:event._id});

    if(data){
      data.localities.forEach((locality:any) => {
        localitiesSelected.forEach((localitySelected:LocalitySelectedType) => {
          if(locality._id===localitySelected._id){
            if(locality.stock<localitySelected.quantity){
              const newPhases = data?.localities?.map((localities: any) => {
                return localities.phases.map((phase: any) => ({
                  _id: phase._id,
                  status: phase.status,
                  public: phase.public,
                  position: phase.position,
                  type: phase.type,
                  name: phase.name,
                  stock: phase.stock,
                  typePublic: phase.typePublic,
                  priceWithVAT: phase.priceWithVAT,
                  priceWithoutVAT: phase.priceWithoutVAT,
                  startDate: phase.startDate,
                  endDate: phase.endDate,
                  locality: phase.locality,
                  log: phase.log,
                  commisionIva: phase.commisionIva,
                  commisionNoIva: phase.commisionNoIva,
                  acronym: phase.acronym,
                  description: localities.description,
                  sequenceStart: phase.sequenceStart,
                  typeNumbering: localities.typeNumbering,
                  localityStock: localities.stock,
                }));
              });
          
              setPhases(newPhases?.flat());
              setErrorList([`La localidad ${locality.description} solo tiene ${locality.stock} tickets disponibles`]);

              setTimeout(()=>setErrorList([]),5000);
            }
          }
        });
      });
    }
  }

  const pay = async(openModal: Function)=>{
    const isSubscription = event.publicType==='Abonados';
    const userDataUpdated = localStorage.getItem("user");
    let userUpdated:UserType;
    
    if(!isLoggedIn) {
      openModal();
      return;
    }
    
    if (userDataUpdated) {
      userUpdated = JSON.parse(userDataUpdated) as UserType;
      if(!userUpdated.ci || !userUpdated?.phone || !userUpdated?.username){
        openModal();
        return;
      }
    }
    setHaveProfile(true);
    setHavePhone(true);
    verifySeatsSelected();
    console.log('Antes de verifyStock:', localitiesSelected);
    await verifyStock();
    console.log('Después de verifyStock:', localitiesSelected);  }

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        <div className="flex justify-between items-center">
          <Badge name={event.category} color="yellow" />
          {/* <LikeSaveBtns /> */}
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {event.nameEvent}
        </h2>

        {/* 3 */}
        <div className="flex items-center space-x-4">
          {/* <StartRating /> */}
          {/* <span>·</span> */}
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1">{event.city.description}, {event?.place}</span>
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <span>
            <i className="las la-calendar"></i>
            <span className="ml-1">{eventDate.customDate}</span>
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <span>
            <i className="las la-clock"></i>
            <span className="ml-1">{eventDate.customTime}</span>
          </span>
        </div>


        {/* 4 */}
        <div className="flex items-center">
          <Avatar hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              Kevin Francis
            </span>
          </span>
        </div>

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* 6 */}
        <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex items-center space-x-3 ">
            <i className=" las la-user text-2xl "></i>
            <span className="">
              6 <span className="hidden sm:inline-block">guests</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bed text-2xl"></i>
            <span className=" ">
              6 <span className="hidden sm:inline-block">beds</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bath text-2xl"></i>
            <span className=" ">
              3 <span className="hidden sm:inline-block">baths</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-door-open text-2xl"></i>
            <span className=" ">
              2 <span className="hidden sm:inline-block">bedrooms</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Acerca del evento</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            {event.description}
          </span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderRequirements = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Requisitos</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            {event.requirementsDescription}
          </span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderConditions = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Condiciones</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>
            * Al ingresar al evento se solicitará un documento de identificación para verificar las compras con descuentos(Tercera Edad/Niños/Personas con Discapacidad).
          </span>
          <br />
          <br />
        </div>
      </div>
    );
  };

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Amenities </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {` About the property's amenities and services`}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {Amenities_demos.filter((_, i) => i < 12).map((item) => (
            <div key={item.name} className="flex items-center space-x-3">
              <i className={`text-3xl las ${item.icon}`}></i>
              <span className=" ">{item.name}</span>
            </div>
          ))}
        </div>

        {/* ----- */}
        <div className="w-14 border-b border-neutral-200"></div>
        <div>
          <ButtonSecondary onClick={openModalAmenities}>
            View more 20 amenities
          </ButtonSecondary>
        </div>
        {renderMotalAmenities()}
      </div>
    );
  };

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Amenities
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalAmenities} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    {Amenities_demos.filter((_, i) => i < 1212).map((item) => (
                      <div
                        key={item.name}
                        className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
                      >
                        <i
                          className={`text-4xl text-neutral-6000 las ${item.icon}`}
                        ></i>
                        <span>{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSection4 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Room Rates </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Prices may increase on weekends or holidays
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="flow-root">
          <div className="text-sm sm:text-base text-neutral-6000 dark:text-neutral-300 -mb-4">
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4  flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Friday - Sunday</span>
              <span>$219</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Rent by month</span>
              <span>-8.34 %</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Minimum number of nights</span>
              <span>1 night</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Max number of nights</span>
              <span>90 nights</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSection5 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Host Information</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* host */}
        <div className="flex items-center space-x-4">
          <Avatar
            hasChecked
            hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
            sizeClass="h-14 w-14"
            radius="rounded-full"
          />
          <div>
            <a className="block text-xl font-medium" href="##">
              Kevin Francis
            </a>
            <div className="mt-1.5 flex items-center text-sm text-neutral-500 dark:text-neutral-400">
              <StartRating />
              <span className="mx-2">·</span>
              <span> 12 places</span>
            </div>
          </div>
        </div>

        {/* desc */}
        <span className="block text-neutral-6000 dark:text-neutral-300">
          Providing lake views, The Symphony 9 Tam Coc in Ninh Binh provides
          accommodation, an outdoor swimming pool, a bar, a shared lounge, a
          garden and barbecue facilities...
        </span>

        {/* info */}
        <div className="block text-neutral-500 dark:text-neutral-400 space-y-2.5">
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span>Joined in March 2016</span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
            <span>Response rate - 100%</span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            <span>Fast response - within a few hours</span>
          </div>
        </div>

        {/* == */}
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <ButtonSecondary href="/author">See host profile</ButtonSecondary>
        </div>
      </div>
    );
  };

  const renderSection6 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Reviews (23 reviews)</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* Content */}
        <div className="space-y-5">
          <FiveStartIconForRate iconClass="w-6 h-6" className="space-x-0.5" />
          <div className="relative">
            <Input
              fontClass=""
              sizeClass="h-16 px-4 py-3"
              rounded="rounded-3xl"
              placeholder="Share your thoughts ..."
            />
            <ButtonCircle
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              size=" w-12 h-12 "
            >
              <ArrowRightIcon className="w-5 h-5" />
            </ButtonCircle>
          </div>
        </div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <CommentListing className="py-8" />
          <div className="pt-8">
            <ButtonSecondary>View more 20 reviews</ButtonSecondary>
          </div>
        </div>
      </div>
    );
  };

  const renderSection7 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            San Diego, CA, United States of America (SAN-San Diego Intl.)
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}
        <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
          <div className="rounded-xl overflow-hidden z-0">
            <iframe
              title="x"
              width="100%"
              height="100%"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAGVJfZMAKYfZ71nzL_v5i3LjTTWnCYwTY&q=Eiffel+Tower,Paris+France"
            ></iframe>
          </div>
        </div>
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Things to know</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Cancellation policy</h4>
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            Refund 50% of the booking value when customers cancel the room
            within 48 hours after successful booking and 14 days before the
            check-in time. <br />
            Then, cancel the room 14 days before the check-in time, get a 50%
            refund of the total amount paid (minus the service fee).
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Check-in time</h4>
          <div className="mt-3 text-neutral-500 dark:text-neutral-400 max-w-md text-sm sm:text-base">
            <div className="flex space-x-10 justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
              <span>Check-in</span>
              <span>08:00 am - 12:00 am</span>
            </div>
            <div className="flex space-x-10 justify-between p-3">
              <span>Check-out</span>
              <span>02:00 pm - 04:00 pm</span>
            </div>
          </div>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Special Note</h4>
          <div className="prose sm:prose">
            <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">
              <li>
                Ban and I will work together to keep the landscape and
                environment green and clean by not littering, not using
                stimulants and respecting people around.
              </li>
              <li>Do not sing karaoke past 11:30</li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <TimerProvider>
      <div className="listingSectionSidebar__wrap shadow-xl">
         <Helmet>
                <title>Bee || {event.nameEvent}</title>
          </Helmet>
        {event.isFree && (
          <div className="flex justify-between">
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
            ¡Gran noticia! 
            <br />
            Este evento es totalmente gratuito.
            <br />
            Es una excelente oportunidad 
            <br />
            para disfrutar de una experiencia 
            <br />
            increíble sin costo alguno. 🌟✨ 
            <br />
            ¡No te lo pierdas, 
            <br />
            te esperamos con mucho entusiasmo! 🥳🎈
            </span>
        </div> 
        )
        }
        {
           phases?.length > 0 && (
            phases.map((phase:PhaseType,index)=>(
              <NcInputNumberLocalities
                enablePurchase={currentTime>new Date(event.publicationTime)}
                startTime={event.publicationTime}
                localityId={phase.locality}
                key={index}
                className="w-full"
                onChange={(value) => handleRowChange(value, phase)}
                maxQuantity={event.maximunTickets}
                currentQuantity={cantTickets}
                max={phase.stock>phase.localityStock?phase.localityStock:phase.stock}
                min={0}
                label={phase.description.split("*")[0]}
                desc={`$${phase.priceWithVAT} ${phase.description.split("*")[1]?phase.description.split("*")[1]+'*':''}`}
                haveSelection={phase.typeNumbering==="Alfanumérico"}
                endTime={event.endTime}
                localitiesSelected={localitiesSelected}
                setLocalitiesSelected={setLocalitiesSelected}
              />
            ))
          )
        }
        {!event.isFree && cantTickets > 0&&<label className="block">
          <span className="text-neutral-800 dark:text-neutral-200 animate-fadeIn">
            Tienes un cupón?
          </span>
          <Input
            className="mt-1 animate-fadeIn"
            placeholder="Ingresa tu cupón aquí"
            maxLength={10}
            onChange={handleDiscount}
          />
          {couponMessageError !== '' && (
            <p className="mt-2 text-red-500 text-xs">{couponMessageError}</p>
          )}
        </label>}

        
        {/* SUM */}
        {/* <div className="flex flex-col space-y-4">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>$119 x 3 night</span>
            <span>$357</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>$0</span>
          </div>
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>$199</span>
          </div>
        </div> */}

        {phases?.length > 0&&<div className="listingSectionSidebar__wrap shadow-xl p-4 space-y-2 rounded-lg">
          <div className="flex justify-between">
            <span>Subtotal 0%:</span>
            <span>${subtotal0.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>Subtotal 15%:</span>
            <span>${subtotal15.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>IVA:</span>
            <span>${vat.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>Fee Bee:</span>
            <span>${totalCommision.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>Fee Bee IVA:</span>
            <span>${totalCommisionVat.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-red-500">
            <span>Descuento:</span>
            <span>${discount.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-bold border-t pt-2 text-green-500">
            <span>Total:</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div>}
        <NcModal
          renderTrigger={(openModal) => (
              <ButtonPrimary disabled={cantTickets<=0} loading={verifyingCoupon} onClick={()=>pay(openModal)} className="w-full">Pagar</ButtonPrimary>
          )}
          contentExtraClass="w-full sm:w-1/2"
          modalTitle="Advertencia"
          renderContent={() =>isLoggedIn? (
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
              Para proceder con la compra, debes {` `}
              <a href="/profile" target="_blank" rel="noopener noreferrer" className="underline">
                completar tu perfil
              </a>
            </span>
          ): (
            <span className="block text-center text-neutral-700 dark:text-neutral-300">
            Para proceder con la compra, {` `}
            <a href="/login" target="_blank" rel="noopener noreferrer" className="underline">
              inicia sesión
            </a>
            . Si no tienes una cuenta, {` `}
            <a href="/signup" target="_blank" rel="noopener noreferrer" className="underline">
              regístrate aquí
            </a>
            .
            </span>
          )
          }
        />
        {errorList.length > 0 && (
          <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex flex-col gap-2">
            <span>Debes seleccionar:</span>
            {errorList.map((error: string, index) => (
              <div key={index}>{error}</div> // Cada error en una nueva línea
            ))}
          </div>
        )}

      </div>
      </TimerProvider>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage">
      {/*  HEADER */}
      <header className="rounded-md sm:rounded-xl">
        <div className="relative grid grid-cols-3 sm:grid-cols-3 gap-1 sm:gap-2">
          <div className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden">
            <img
              className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
              src={event.img}
              alt=""
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
            />
            <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
          </div>
          <div className="relative rounded-md sm:rounded-xl overflow-hidden">
            <div className="aspect-w-4 aspect-h-3 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0 relative">
              <iframe
                title="Mapa"
                className="absolute inset-0 w-full h-full"
                loading="lazy"
                allowFullScreen
                src={`https://www.google.com/maps?q=${event.lat},${event.lng}&hl=es&z=15&output=embed`}
              ></iframe>
              {event.secretLocation && (
                <div className="absolute inset-0 bg-white/50 backdrop-blur-md flex items-center justify-center z-10">
                  <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-semibold text-gray-800">
                    Ubicación secreta
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className={`relative rounded-md sm:rounded-xl overflow-hidden`}>
            <div className="aspect-w-4 aspect-h-3 sm:aspect-h-3 ring-1 ring-black/10 rounded-xl z-0">
              <div className="rounded-xl overflow-hidden z-0">
                <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src= {event.haveDistribution?event.imgDistributionPlace:"https://bee.com.ec/view/banner/67361e0df3d3dcd6f05644de.png"}
                alt=""
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
                {/* <div className="absolute inset-0 bg-black/50 backdrop-blur-2xl flex items-center justify-center z-10">
                  <span className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-semibold text-primary-500">
                    {event.nameEvent}
                  </span>
                </div> */}
              </div>
            </div>
          </div>
          

        </div>
      </header>

      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {event.existRequirements && renderRequirements()}
          {renderConditions()}
          {/* {renderSection3()} */}
          {/* {renderSection4()} */}
          {/* <SectionDateRange />
          {renderSection5()}
          {renderSection6()}
          {renderSection7()} */}
          {renderSection8()}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function EventDetailPage() {
  const { id } = useParams();
  const [event,setEvent] = useState<EventType|null>(null);
  const {data}= useGetEventQuery(id);
  useEffect(() => {
    if(data){
      const item = data.eventDB;
      const eventSelected:EventType= {
        _id:item._id,
        nameEvent:item.nameEvent,
        date:item.date,
        category:item.category,
        city:{
          _id:item.city._id,
          description:item.city.description,
          province: item.city.province,
        },
        acronym:item.acronym,
        description:item.description,
        payments:item.payments,
        sponsors:item.sponsors,
        existRequirements:item.existRequirements,
        requirementsDescription:item.requirementsDescription,
        place:item.place,
        available:item.available,
        publicType:item.publicType,
        startTime:item.startTime,
        endTime:item.endTime,
        isFree:item.isFree,
        isDelete:item.isDelete,
        img:item.img,
        lat:item.lat,
        lng:item.lng,
        secretLocation:item.secretLocation,
        iva:item.iva,
        hasCapacity:item.hasCapacity,
        maximunTickets:item.maximunTickets,
        valueIva:item.valueIva,
        imgHeader:item.imgHeader,
        haveSubscribers:item.haveSubscribers,
        haveDistribution:item.haveDistribution,
        type:item.type,
        publicationDate:item.publicationDate,
        publicationTime:item.publicationTime,
        specialDiscounts:item.specialDiscounts,
        percentageSpecialDiscounts:item.percentageSpecialDiscounts,
        imgDistributionPlace:item.imgDistributionPlace,
        localitiesFrom:item.localitiesFrom,
        salesman:item.salesman,
      }
      setEvent(eventSelected);
    }

  }
  , [data]);
  return (
   !event?<Loading/>:
    <DetailPagetLayout event={event}>
      <EventPageContainer event={event}/>
    </DetailPagetLayout>
  );
}
